import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const serviceCategories = [
    {
      title: 'Color',
      description: 'From root retouches to balayage, our color specialists bring your vision to life.',
      price: 'Starting at $70',
    },
    {
      title: 'Cuts',
      description: 'Precision haircuts tailored to your style, for men, women, and kids.',
      price: 'Starting at $25',
    },
    {
      title: 'Styling',
      description: 'Blowouts, formal updos, and iron work for any occasion.',
      price: 'Starting at $45',
    },
    {
      title: 'Treatments',
      description: 'Olaplex treatments to keep your hair healthy and beautiful.',
      price: 'Starting at $25',
    },
  ];

  const features = [
    {
      title: '36+ Years Experience',
      description: 'Decades of expertise in color, cuts, and styling for a diverse clientele.',
    },
    {
      title: 'Color Specialists',
      description: 'Advanced techniques including balayage, dimensional color, and creative toning.',
    },
    {
      title: 'Men & Women Welcome',
      description: 'A welcoming environment with services tailored for everyone.',
    },
    {
      title: 'Flexible Hours',
      description: 'Extended evening hours on Thursdays and Fridays for your convenience.',
    },
  ];

  return (
    <main className="home">
      {/* Hero Section */}
      <section className="hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/salon.jpg)` }}>
        <div className="hero__overlay"></div>
        <div className="hero__content">
          <span className="hero__eyebrow">CHESTERFIELD, MICHIGAN</span>
          <h1 className="hero__title">Epic Hair Salon</h1>
          <p className="hero__tagline">Where beauty meets expertise</p>
          <div className="hero__ctas">
            <a
              href="https://epichairsalon.glossgenius.com/services"
              target="_blank"
              rel="noopener noreferrer"
              className="hero__btn-solid"
            >
              Book Appointment
            </a>
            <Link to="/services" className="hero__btn-outline">
              Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section services-preview">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-preview__grid">
            {serviceCategories.map((service, index) => (
              <div className="services-preview__card" key={index}>
                <h3 className="services-preview__card-title">{service.title}</h3>
                <p className="services-preview__card-desc">{service.description}</p>
                <span className="services-preview__price">{service.price}</span>
                <Link to="/services" className="services-preview__link">
                  View Details &rarr;
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="section about-preview">
        <div className="container">
          <div className="about-preview__grid">
            <div className="about-preview__text">
              <h2 className="about-preview__heading">Welcome to Epic Hair Salon</h2>
              <p className="about-preview__desc">
                Located in the heart of Chesterfield, Michigan, Epic Hair Salon is home to a talented
                team of stylists who are passionate about making you look and feel your best. With over
                36 years of combined experience, we specialize in color, precision cuts, and styling
                that brings out your natural beauty.
              </p>
              <p className="about-preview__desc">
                We believe great hair starts with a great conversation. Our stylists take the time to
                understand your vision, lifestyle, and hair goals to create a look that is uniquely yours.
              </p>
              <Link to="/about" className="about-preview__link">
                Meet Our Team &rarr;
              </Link>
            </div>
            <div className="about-preview__decorative">
              <div className="about-preview__decorative-box"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-us">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>
          <div className="why-us__grid">
            {features.map((feature, index) => (
              <div className="why-us__item" key={index}>
                <div className="why-us__accent"></div>
                <h3 className="why-us__item-title">{feature.title}</h3>
                <p className="why-us__item-desc">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="container">
          <h2 className="cta-banner__title">Ready for Your Next Look?</h2>
          <p className="cta-banner__text">
            Book your appointment today and let our experienced stylists create something beautiful.
          </p>
          <a
            href="https://epichairsalon.glossgenius.com/services"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-banner__btn"
          >
            Book Your Appointment
          </a>
        </div>
      </section>
    </main>
  );
}

export default Home;
